/**
 * Configuração da Redux Store
 */

import { configureStore } from '@reduxjs/toolkit';
import mapReducer from './slices/mapSlice';
import searchReducer from './slices/searchSlice';
import groupsReducer from './slices/groupsSlice';

export const store = configureStore({
  reducer: {
    map: mapReducer,
    search: searchReducer,
    groups: groupsReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignorar verificação de serialização para datas
        ignoredActions: ['search/startSearch', 'search/searchSuccess'],
        ignoredPaths: ['search.results', 'search.lastSearch']
      }
    })
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;





